exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".with-half-radius[data-v-fe90f57a]{color:#fff;border-radius:5px 0 0 5px;white-space:nowrap}.with-full-radius[data-v-fe90f57a]{color:#fff;border-radius:5px;white-space:nowrap}", ""]);

// exports
